import ReactDOM from 'react-dom';
import { FC } from 'react';
import styles from './ActionBar.module.scss';
import classNames from 'classnames';

type ActionBarProps = {
  children: JSX.Element;
  setOpen: (e: boolean) => void;
};

export const ActionBar: FC<ActionBarProps> = ({ children, setOpen }) => {
  const handlerClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen(false);
  };

  return ReactDOM.createPortal(
    <div
      className={classNames(styles.root, 'mantine-visible-from-sm')}
      onMouseDown={handlerClose}>
      <div className={styles.bar} onMouseDown={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>,
    document.body,
  );
};
